// extracted by mini-css-extract-plugin
export default {"poltrone__tile":"PoltroneTile_poltrone__tile__0ML3V","poltrone__nome":"PoltroneTile_poltrone__nome__7udij","poltrone__buttons":"PoltroneTile_poltrone__buttons__TlGO1"};